import React from 'react';
import styles from '../PostPurchaseStep.scss';

interface EmbeddedVideoPlayerProps {
  src: string;
  title: string;
}

export function EmbeddedVideoPlayer({ src, title }: EmbeddedVideoPlayerProps) {
  return (
    <div className={styles.postPurchaseVideoPlayer}>
      <iframe
        className={styles.postPurchaseVideoEmbed}
        src={src}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}
